<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="surgery-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            :addButton="{ enabled: false, permission: 'default' }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
        >
            <template slot="filter">
                <el-col :md="8" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <!-- <el-col :span="4">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="手术区"></item-input>
                </el-col> -->
                <el-col :span="4">
                    <item-input type="multiselect" v-model="prjectId" :options="projects" :clearable="true" placeholder="项目"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="isyc" :options="isycArr" :clearable="true" placeholder="异常体征"></item-input>
                </el-col>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SignModification`,
    props: {},
    data() {
        return {
            title: `体征记录`,
            url: {
                baseURL: `/api/AcisSystem/PhysioParamLog`,
                get: () => {
                    return this.listGet()
                }
            },
            buttons: [],
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            o_dic_operating_ward_id: undefined, // 排程手术区
            issetoperatingward: false,
            projects: [], // 项目数据
            prjectId: [],
            isycArr: [{ label: `是`, value: 1 }, { label: `否`, value: 2 }],
            isyc: null
        }
    },
    created() {},
    computed: {
        ...mapGetters([`sys_enums`, `active_ward`, `operation_ward_auth`, `drug/drug_type`]),
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `140`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    width: `200`,
                    isListable: true,
                    searchable: true,
                    options: this.operation_ward_auth
                },
                {
                    type: `string`,
                    prop: `physio_param_name`,
                    label: `项目`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `record_type`,
                    label: `单据类型`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.recordType
                },
                {
                    type: `datetime`,
                    prop: `data_dt`,
                    label: `采集时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `old_value`,
                    label: `原始数值`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `string`,
                    prop: `new_value`,
                    label: `修改数值`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `datetime`,
                    prop: `modify_dt`,
                    label: `修改时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `修改人`,
                    width: `140`,
                    isListable: true
                }
            ]
        },
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        }
    },
    mounted() {
        this.getProjects()
    },
    methods: {
        listGet() {
            return new Promise((resolve, reject) => {
                let that = this
                let req = this.myaxios.get(
                    `/api/AcisSystem/PhysioParamLog/GetByTime?from=${this.rdate[0]}&to=${this.$moment(this.rdate[1])
                        .add(1, `days`)
                        .format(`YYYY/MM/DD`)}`,
                    {}
                )
                req.then(data => {
                    console.log(`Log`, data)
                    let newData = JSON.parse(JSON.stringify(data))
                    // 通过手术区id、过滤手术区
                    // if (this.dic_operating_ward_id) {
                    //     newData = data.filter(item => {
                    //         return item.surgery_application.dic_operating_ward_id == this.dic_operating_ward_id
                    //     })
                    // }
                    if (this.prjectId.length > 0) {
                        newData = data.filter(item => {
                            return this.prjectId.indexOf(item.dic_physio_param.id) != -1
                        })
                    }
                    let res = newData.map(item => {
                        if (item && item.dic_physio_param) {
                            if ((item.new_value && ((item.dic_physio_param.lower_warn && item.dic_physio_param.lower_warn > item.new_value) ||
                                (item.dic_physio_param.upper_warn && item.dic_physio_param.upper_warn < item.new_value))) ||
                            (!item.new_value && ((item.dic_physio_param.lower_warn && item.dic_physio_param.lower_warn > item.old_value) ||
                                (item.dic_physio_param.upper_warn && item.dic_physio_param.upper_warn < item.old_value)))) {
                                item.isyc = 1
                                item.row_style = { "color": `red !important` }
                            } else {
                                item.isyc = 2
                            }
                        }
                        return {
                            ...item,
                            modifier: item.modifier,
                            dic_operating_ward_id: item.surgery_application.dic_operating_ward_id, // 手术区id
                            patient_name: item.surgery_application.patient_name, // 患者姓名
                            physio_param_name: item.dic_physio_param.name, // 项目name
                            physio_param_id: item.dic_physio_param.id // 项目id
                        }
                    })
                    if (that.isyc > 0) {
                        res = res.filter(item => {
                            return that.isyc == item.isyc
                        })
                    }
                    console.log(res)
                    resolve(res)
                }).catch(e => reject(e))
            })
        },
        getProjects() {
            this.myaxios.get(`/api/AcisSystem/PhysioParam/Get?surgeryId=0&current_surgery=0&record_type=1`).then(res => {
                this.projects = res.map(item => {
                    return { value: item.id, label: item.name }
                })
            })
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        dic_operating_ward_id: function() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        prjectId(e) {
            this.$refs[`surgery-list`].ReloadListData()
        },
        isyc(e) {
            this.$refs[`surgery-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SignModification/index.vue